"use client";

import { ChartData, ChartOptions } from "chart.js";
import { nb } from "date-fns/locale";
import { Line } from "react-chartjs-2";
import { IFundPriceHistory } from "@portal/types/api/IFundPriceHistory";
import { chartJsGridColor, chartJsTextColor } from "@portal/helpers/chartJs";

export interface RiskLineSeries {
  name: string;
  color: string;
  priceHistory: IFundPriceHistory[];
}

interface Props {
  series: RiskLineSeries[];
}

/**
 * Chart.js version of the risk multi-line fund price chart.
 * @param interface
 * @returns a chart.
 */
export const RiskChart = ({ series }: Props) => {
  const data: ChartData<"line"> = {
    datasets: series.map(s => ({
      label: s.name,
      borderColor: s.color,
      backgroundColor: s.color,
      borderWidth: 1,
      tension: 0,
      data: s.priceHistory.map(p => ({ x: new Date(p.navDate).getTime(), y: p.price })),
    })),
  };

  const options: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    elements: { point: { radius: 0, hoverRadius: 4 } },
    scales: {
      x: {
        type: "time",
        adapters: { date: { locale: nb } },
        time: { tooltipFormat: "dd.MM.yyyy", displayFormats: { day: "d. MMM", month: "MMM ''yy", year: "yyyy" } },
        ticks: { color: chartJsTextColor(), maxRotation: 0, autoSkip: true, maxTicksLimit: 6 },
        grid: { display: false },
      },
      y: { ticks: { color: chartJsTextColor() }, grid: { color: chartJsGridColor() } },
    },
    plugins: {
      legend: { position: "bottom", labels: { color: chartJsTextColor(), boxWidth: 12 } },
    },
  };

  return (
    <div className="h-96">
      <Line data={data} options={options} />
    </div>
  );
};
